import BasicInfoVisual from '../../../styles/images/basic-info-visual.png';

const CreateAlbumLayout = (props: any) => {
    return (
        <>
            <div className="main-wrap">
                <div className="leftPane">
                    <div className="leftPaneWrap">
                        <div className="leftPaneBodyWrap">
                            <div className="leftPaneBody">
                                <div className="qs_body aos-init aos-animate" data-aos="fade-right" data-nextpage="undergraduate.html">
                                    <div className="steps_questions">{props.children}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="rightPane basic-information">
                    <div className="rightPaneWrap">
                        <div className="rightPaneBodyWrap">
                            <div className="rightPaneBody aos-init aos-animate" data-aos="fade-left">
                                <div className="step step_1">
                                    <h2 className="stepHeader">Why Keep a Record of Memories?</h2>
                                    <div className="listed_points">
                                        <ul>
                                            <li>
                                                Everyone remembers school in a different way. By updating your photos and videos, you
                                                complete the memories of all your alumni.
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="step_img">
                                        <img src={BasicInfoVisual} className="img-fluid float_horizontal_animate" width="100%" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateAlbumLayout;
